import React from 'react';
import PropTypes from 'prop-types';

// Components
import {
    Paragraph,
    IconCheckmarkCircle,
    IconExclamationCircle,
    Flex,
    Spacer,
} from '@zillow/constellation';

import { StyledNoWrapButton } from 'app/shared/StyledComponents/StyledComponents';

import { StyledCard } from './StyledComponents';
import MESSAGE_MODULE_TYPES from '../../MESSAGE_MODULE_TYPES';

const propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    ctaPrimaryButton: PropTypes.shape({
        text: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
    }),
    ctaSecondaryButton: PropTypes.shape({
        text: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
    }),
    closeMessageModule: PropTypes.func.isRequired,
    dismissibleActionId: PropTypes.string,
};

const defaultProps = {
    ctaPrimaryButton: null,
    ctaSecondaryButton: null,
    dismissibleActionId: null,
};

const PaymentsMessageModule = ({
    title,
    description,
    ctaPrimaryButton,
    ctaSecondaryButton,
    type,
    closeMessageModule,
    dismissibleActionId,
}) => {
    if (type === MESSAGE_MODULE_TYPES.CONFIRMATION) {
        return (
            <StyledCard isDisabled={true} data-test="confirmation-payments-message-card">
                <Flex display="flex" justifyContent="space-between">
                    <Paragraph fontType="bodyHeading">{title}</Paragraph>
                    <IconCheckmarkCircle size="sm" fontColor="green400" />
                </Flex>
                <Paragraph fontType="bodySmall" paddingTop="sm" paddingBottom="md">{description}</Paragraph>
                {
                    (ctaPrimaryButton && ctaPrimaryButton.text && ctaPrimaryButton.url) && (
                        <StyledNoWrapButton
                            forwardedAs="a"
                            href={ctaPrimaryButton.url}
                            buttonType="primary"
                            size="sm"
                            fluid={true}
                            data-test="confirmation-payments-card-primary-cta"
                        >
                            {ctaPrimaryButton.text}
                        </StyledNoWrapButton>
                    )
                }
                {
                    (ctaSecondaryButton && ctaSecondaryButton.text && ctaSecondaryButton.url) && (
                        <Spacer paddingTop="xs">
                            <StyledNoWrapButton
                                forwardedAs="a"
                                href={ctaSecondaryButton.url}
                                buttonType="secondary"
                                size="sm"
                                fluid={true}
                                data-test="confirmation-payments-card-secondary-cta"
                            >
                                {ctaSecondaryButton.text}
                            </StyledNoWrapButton>
                        </Spacer>
                    )
                }
            </StyledCard>
        );
    }

    if (type === MESSAGE_MODULE_TYPES.DISMISSIBLE_CONFIRMATION) {
        return (
            <StyledCard isDisabled={true} data-test="dismissible-confirmation-payments-message-card">
                <Flex display="flex" justifyContent="space-between">
                    <Paragraph fontType="bodyHeading">{title}</Paragraph>
                    <IconCheckmarkCircle size="sm" fontColor="green400" />
                </Flex>
                <Paragraph fontType="bodySmall" paddingTop="sm" paddingBottom="md">{description}</Paragraph>
                {
                    (ctaPrimaryButton && ctaPrimaryButton.text) && (
                        <StyledNoWrapButton
                            buttonType="primary"
                            size="sm"
                            fluid={true}
                            data-test="dismissible-confirmation-payments-card-primary-cta"
                            onClick={() => closeMessageModule(dismissibleActionId)}
                        >
                            {ctaPrimaryButton.text}
                        </StyledNoWrapButton>
                    )
                }
                {
                    (ctaSecondaryButton && ctaSecondaryButton.text && ctaSecondaryButton.url) && (
                        <Spacer paddingTop="xs">
                            <StyledNoWrapButton
                                forwardedAs="a"
                                href={ctaSecondaryButton.url}
                                buttonType="secondary"
                                size="sm"
                                fluid={true}
                                data-test="dismissible-confirmation-payments-card-secondary-cta"
                            >
                                {ctaSecondaryButton.text}
                            </StyledNoWrapButton>
                        </Spacer>
                    )
                }
            </StyledCard>
        );
    }
    if (type === MESSAGE_MODULE_TYPES.WARNING) {
        return (
            <StyledCard isDisabled={true} data-test="warning-payments-message-card" type={type}>
                <Flex display="flex" justifyContent="space-between">
                    <Paragraph fontType="bodyHeading">{title}</Paragraph>
                    <IconExclamationCircle size="sm" fontColor="caution" />
                </Flex>
                <Paragraph fontType="bodySmall" paddingTop="sm" paddingBottom="md">{description}</Paragraph>
                {
                    (ctaPrimaryButton && ctaPrimaryButton.text && ctaPrimaryButton.url) && (
                        <StyledNoWrapButton
                            forwardedAs="a"
                            href={ctaPrimaryButton.url}
                            buttonType="primary"
                            size="sm"
                            fluid={true}
                            data-test="warning-payments-card-primary-cta"
                        >
                            {ctaPrimaryButton.text}
                        </StyledNoWrapButton>
                    )
                }
                {
                    (ctaSecondaryButton && ctaSecondaryButton.text && ctaSecondaryButton.url) && (
                        <Spacer paddingTop="xs">
                            <StyledNoWrapButton
                                forwardedAs="a"
                                href={ctaSecondaryButton.url}
                                buttonType="secondary"
                                size="sm"
                                fluid={true}
                                data-test="warning-payments-card-secondary-cta"
                            >
                                {ctaSecondaryButton.text}
                            </StyledNoWrapButton>
                        </Spacer>
                    )
                }
            </StyledCard>
        );
    }

    return null;
};

PaymentsMessageModule.propTypes = propTypes;
PaymentsMessageModule.defaultProps = defaultProps;

export default PaymentsMessageModule;
